var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { Component, Schema, type } from "./decorators/type.js";
var __defProp2 = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp2(target, key, result);
  return result;
};
let RandomSchema = class extends Schema {
  constructor() {
    super(...arguments);
    __publicField(this, "random");
    __publicField(this, "seed");
    __publicField(this, "seedNumber");
  }
};
__decorateClass([
  type("object")
], RandomSchema.prototype, "random", 2);
__decorateClass([
  type("string")
], RandomSchema.prototype, "seed", 2);
__decorateClass([
  type("number")
], RandomSchema.prototype, "seedNumber", 2);
RandomSchema = __decorateClass([
  Component("Random")
], RandomSchema);
const __vite_glob_0_7 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get RandomSchema() {
    return RandomSchema;
  }
}, Symbol.toStringTag, { value: "Module" }));
export {
  RandomSchema as R,
  __vite_glob_0_7 as _
};
//# sourceMappingURL=Random-b6daba3a.js.map
